import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Building2, Users, Mail, Phone, Calendar, MessageSquare } from 'lucide-react';
import { sendFormData } from '../utils/sendForm';
import Notification from './Notification';
import './Info.css';

const Info = () => {
  const [notification, setNotification] = useState({ show: false, type: 'success', title: '', message: '' });
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      await sendFormData({ type: 'info-entreprise-privatisation', ...data }, 'info');
      reset();
      setNotification({
        show: true,
        type: 'success',
        title: 'Demande envoyée !',
        message: 'Merci ! Nous revenons vers vous très vite pour votre projet d\'événement.'
      });
    } catch (e) {
      setNotification({
        show: true,
        type: 'error',
        title: 'Erreur lors de l\'envoi',
        message: 'Une erreur est survenue. Merci d\'essayer plus tard.'
      });
    }
  };

  return (
    <section className="info-page">
      <div className="container">
        <header className="info-header">
          <h1>Entreprise & Privatisation</h1>
          <p>Organisez un événement gourmand dans l’univers Pinky Cloud.</p>
        </header>

        <div className="info-grid">
          {/* Colonne descriptions */}
          <div className="info-content">
            <article className="info-card">
              <div className="info-card-icon" aria-hidden>
                <Building2 size={22} />
              </div>
              <h2>Entreprises</h2>
              <p>
                Chez Pinky Cloud, nous sommes ravis d'offrir nos services aux entreprises pour
                l'organisation de leurs événements. Que ce soit pour un séminaire, une soirée
                d'entreprise ou un team-building, notre restaurant se spécialise dans la création de
                moments mémorables autour de délicieux burgers et hot dogs sucrés. En complément, nous
                proposons une sélection gourmande de pancakes, sans oublier des boissons rafraîchissantes
                telles que des bubble teas et des smoothies. Notre équipe se tient prête à vous
                accompagner dans la personnalisation de votre menu, afin de garantir une expérience
                culinaire unique pour vos collaborateurs et invités. Faites-nous confiance pour
                transformer votre événement en un succès savoureux et convivial !
              </p>
            </article>

            <article className="info-card">
              <div className="info-card-icon" aria-hidden>
                <Users size={22} />
              </div>
              <h2>Particuliers / Privatisation</h2>
              <p>
                Notre boutique est heureuse d'annoncer que nous offrons la possibilité de privatiser
                notre espace pour des événements privés ! Que ce soit pour un évènement privé ou un
                événement professionnel, nous avons tout ce qu'il vous faut pour régaler vos invités.
                Notre restaurant est spécialisé dans des burgers et des hot dogs sucrés qui plairont à
                tous les gourmands. De plus, nous proposons une délicieuse sélection de pancakes, de
                bubble teas et de smoothies pour accompagner vos repas. En choisissant notre boutique
                pour votre événement, vous garantissez une expérience culinaire unique et mémorable.
                N'hésitez pas à nous contacter pour en savoir plus sur nos options de privatisation et
                pour organiser un événement inoubliable dans un cadre convivial et chaleureux.
              </p>
            </article>
          </div>

          {/* Colonne formulaire */}
          <aside className="info-form-wrapper">
            <form className="info-form" onSubmit={handleSubmit(onSubmit)}>
              <input type="text" name="website" style={{display:'none'}} aria-hidden="true" tabIndex="-1" />
              <h3>Demande d’information</h3>
              <div className="form-row">
                <label>Nom complet</label>
                <input type="text" placeholder="Prénom Nom" {...register('name', { required: 'Requis' })} />
                {errors.name && <span className="error">{errors.name.message}</span>}
              </div>
              <div className="form-row two-cols">
                <div>
                  <label>Email</label>
                  <div className="with-icon"><Mail size={16} /><input type="email" placeholder="vous@email.com" {...register('email', { required: 'Requis' })} /></div>
                  {errors.email && <span className="error">{errors.email.message}</span>}
                </div>
                <div>
                  <label>Téléphone</label>
                  <div className="with-icon"><Phone size={16} /><input type="tel" placeholder="+33 1 23 45 67 89" {...register('phone')} /></div>
                </div>
              </div>
              <div className="form-row two-cols">
                <div>
                  <label>Type d’événement</label>
                  <select {...register('type', { required: 'Requis' })}>
                    <option value="">Sélectionner</option>
                    <option value="entreprise">Entreprise</option>
                    <option value="privatisation">Privatisation</option>
                  </select>
                </div>
                <div>
                  <label>Date souhaitée</label>
                  <div className="with-icon"><Calendar size={16} /><input type="date" {...register('date')} /></div>
                </div>
              </div>
              <div className="form-row">
                <label>Message</label>
                <div className="with-icon"><MessageSquare size={16} /><textarea rows="4" placeholder="Parlez-nous de votre projet…" {...register('message')} /></div>
              </div>
              <button type="submit" className="btn-primary-info">Envoyer ma demande</button>
              <p className="form-note">En envoyant ce formulaire, vous acceptez d’être recontacté par Pinky Cloud.</p>
            </form>
          </aside>
        </div>
      </div>
      
      <Notification
        show={notification.show}
        type={notification.type}
        title={notification.title}
        message={notification.message}
        onClose={() => setNotification({ show: false, type: 'success', title: '', message: '' })}
      />
    </section>
  );
};

export default Info;

